/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import apiService from '@services/apiService';

const CLICK_SECTION_ADD = 'CLICK_SECTION_ADD';
const DELETE_OPEN_HOUSE_VALIDATION_RESULT = 'DELETE_OPEN_HOUSE_VALIDATION_RESULT';
const DELETE_ROOM_VALIDATION_RESULT = 'DELETE_ROOM_VALIDATION_RESULT';
const FORM_SUBMITTED = 'FORM_SUBMITTED';
const LOAD_CITY_NAMES = 'LOAD_CITY_NAMES';
const LOAD_CITY_NAMES_SUCCESS = 'LOAD_CITY_NAMES_SUCCESS';
const LOAD_CITY_NAMES_FAIL = 'LOAD_CITY_NAMES_FAIL';
const LOAD_COMBO_BOX_OPTIONS = 'LOAD_COMBO_BOX_OPTIONS';
const LOAD_COMBO_BOX_OPTIONS_SUCCESS = 'LOAD_COMBO_BOX_OPTIONS_SUCCESS';
const LOAD_COMBO_BOX_OPTIONS_FAIL = 'LOAD_COMBO_BOX_OPTIONS_FAIL';
const LOAD_FORM_DEFINITION = 'LOAD_FORM_DEFINITION';
const LOAD_FORM_DEFINITION_SUCCESS = 'LOAD_FORM_DEFINITION_SUCCESS';
const LOAD_FORM_DEFINITION_FAIL = 'LOAD_FORM_DEFINITION_FAIL';
const LOAD_LISTING = 'LOAD_LISTING';
const SET_COMBO_DICTIONARY_ENTRY = 'SET_COMBO_DICTIONARY_ENTRY';
const SET_VALIDATION_RESULT = 'SET_VALIDATION_RESULT';
const SET_OPEN_HOUSE_VALIDATION_RESULT = 'SET_OPEN_HOUSE_VALIDATION_RESULT';
const SET_ROOM_VALIDATION_RESULT = 'SET_ROOM_VALIDATION_RESULT';
const SET_FORM_DATA_STATUS = 'SET_FORM_DATA_STATUS';
const SET_FORM_DATA_COMPLETE = 'SET_FORM_DATA_COMPLETE';

// These actions are used in multiple places of our application. Should we define them here or somewhere else?
const HOME_BUTTON_CLICKED = 'HOME_BUTTON_CLICKED';
const SEARCH_LISTINGS_PAGE_CLICKED = 'SEARCH_LISTINGS_PAGE_CLICKED';

const initialState = {
  allFields: {},
  defaultValues: {},
  cityNames: [],
  comboBoxOptions: [],
  comboIsLoading: false,
  comboSetValueDictionary: {},
  error: false,
  definitionType: null,
  formDefinition: [], // raw def'n returned by service call
  formIsLoading: false,
  formDataStatus: '',
  isLoading: false,
  listingType: null,
  openHouseValidationResult: {},
  operationType: null,
  isCopyOperation: null,
  pageStructure: [], // sorted and structured def'n for rendering
  validationResult: {},
  roomValidationResult: {},
  sectionAddClicks: {},
};

export default function formReducer(state = initialState, action = {}) {
  switch (action.type) {
    case HOME_BUTTON_CLICKED:
    case FORM_SUBMITTED:
      return initialState;
    case LOAD_CITY_NAMES_SUCCESS:
      return {
        ...state,
        cityNames: action.payload.cityNames,
        isLoading: false,
      };
    case LOAD_CITY_NAMES:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_COMBO_BOX_OPTIONS:
      return {
        ...state,
        comboIsLoading: true,
      };
    case LOAD_COMBO_BOX_OPTIONS_FAIL:
      return {
        ...state,
        comboIsLoading: false,
      };
    case LOAD_COMBO_BOX_OPTIONS_SUCCESS: {
      return {
        ...state,
        comboBoxOptions: action.payload.comboBoxOptions,
        comboIsLoading: false,
      };
    }
    case LOAD_FORM_DEFINITION: {
      return {
        ...state,
        operationType: action.payload.operationType,
        isCopyOperation: action.payload.isCopyOperation,
        formIsLoading: true,
        formDataStatus: '',
        validationResult: {},
        roomValidationResult: {},
        sectionAddClicks: {},
      };
    }
    case LOAD_FORM_DEFINITION_SUCCESS: {
      return {
        ...state,
        allFields: action.payload.allFields,
        defaultValues: action.payload.defaultValues,
        comboBoxOptions: [],
        definitionType: action.payload.definitionType,
        formDefinition: action.payload.formDefinition.Data,
        formIsLoading: false,
        listingType: action.payload.listingType,
        pageStructure: action.payload.pageStructure,
      };
    }
    case LOAD_CITY_NAMES_FAIL:
      return {
        ...state,
        isLoading: false,
        /* Error handling */
      };
    case LOAD_FORM_DEFINITION_FAIL:
      return {
        ...state,
        formIsLoading: false,
        /* Error handling */
      };
    case LOAD_LISTING:
      return {
        ...state,
        formType: 'edit',
      };
    case SEARCH_LISTINGS_PAGE_CLICKED:
      return initialState;
    case SET_COMBO_DICTIONARY_ENTRY:
      return {
        ...state,
        comboSetValueDictionary: { ...state.comboSetValueDictionary, ...action.payload },
      };
    case SET_VALIDATION_RESULT: {
      return {
        ...state,
        validationResult: {
          ...state.validationResult,
          ...action.payload,
        },
      };
    }
    case SET_OPEN_HOUSE_VALIDATION_RESULT: {
      return {
        ...state,
        validationResult: {
          ...state.validationResult,
          OpenHouse: {
            ...state.validationResult.OpenHouse,
            ...action.payload,
          },
        },
      };
    }
    case DELETE_OPEN_HOUSE_VALIDATION_RESULT: {
      const openHouseResults = state.validationResult.OpenHouse;
      delete openHouseResults[action.payload];
      return {
        ...state,
        validationResult: {
          ...state.validationResult,
          OpenHouse: {
            ...openHouseResults,
          },
        },
      };
    }
    case SET_ROOM_VALIDATION_RESULT: {
      return {
        ...state,
        roomValidationResult: {
          ...state.roomValidationResult,
          ...action.payload,
        },
      };
    }
    case DELETE_ROOM_VALIDATION_RESULT: {
      const { [action.payload]: removedResult, ...otherResults } = state.roomValidationResult;
      return {
        ...state,
        roomValidationResult: {
          ...otherResults,
        },
      };
    }
    case CLICK_SECTION_ADD: {
      const { sectionAddClicks } = state;
      sectionAddClicks[action.payload.section] = action.payload.section in sectionAddClicks ? sectionAddClicks[action.payload.section] + 1 : 1;
      return {
        ...state,
        sectionAddClicks,
      };
    }
    case SET_FORM_DATA_STATUS: {
      return {
        ...state,
        formDataStatus: action.payload,
      };
    }
    case SET_FORM_DATA_COMPLETE: {
      return {
        ...state,
        formDataStatus: 'initialized',
      };
    }
    default: return state;
  }
}

const updateSectionAddClicks = section => ({
  type: CLICK_SECTION_ADD,
  payload: { section },
});

// Helper functions
const transformResult = (result = []) => {
  const byField = {};

  result.map(entity => {
    const [entityName] = Object.keys(entity);
    byField[entityName] = { ...entity[entityName], id: entityName };
    return null;
  });
  return byField;
};

export const getSortedDefinition = (definition = []) => {
  const sorted = definition.sort((a, b) => {
    const x = (a.pageSortOrder - b.pageSortOrder);
    if (x === 0) {
      return (a.SortOrder - b.SortOrder);
    }
    return x;
  });
  return sorted;
};

const getUniqueSections = (definition = []) => {
  const flags = {};
  const unique = definition.filter(item => {
    if (flags[item.PageName]) {
      return false;
    }
    if (!item.IsVisible) {
      return false;
    }
    flags[item.PageName] = true;
    return true;
  });
  return unique.map(item => ({ sectionName: item.PageName, sectionLabel: item.PageLabel }));
};

const getUniqueGroupNames = (definition = []) => {
  const flags = {};
  const unique = definition.filter(item => {
    if (flags[item.layoutGroupName]) {
      return false;
    }
    flags[item.layoutGroupName] = true;
    return true;
  });
  return unique.map(item => item.layoutGroupName);
};

const buildGroupDict = (uniqueGroupNames, orderedGroups) => {
  const dict = {};
  uniqueGroupNames.map(name => {
    // grab all fields that match name
    const matchingFields = orderedGroups.filter(field => field.layoutGroupName === name);
    // insert into dict
    dict[name] = [...matchingFields];
    return null;
  });
  return dict;
};

const deriveChildren = (sortedDefinition, layoutGroupDict) => {
  const flags = {};
  const children = [];
  sortedDefinition.map(item => {
    if ((item.layoutGroupName) && (!flags[item.layoutGroupName])) {
      flags[item.layoutGroupName] = true;
      children.push({
        isGroup: true,
        groupName: item.layoutGroupName,
        groupType: item.layoutGroupType,
        fields: [...layoutGroupDict[item.layoutGroupName]],
        PageName: item.PageName, // necessary for next step
      });
    } else if (!flags[item.layoutGroupName]) {
      children.push({
        isGroup: false,
        ...item,
      });
    }
    return null;
  });
  return children;
};

const createRenderStructure = (uniqueSections, sectionChildren) => {
  const structure = [];
  uniqueSections.map(section => {
    structure.push({
      sectionName: section.sectionName,
      sectionLabel: section.sectionLabel,
      children: sectionChildren.filter(child => child.PageName === section.sectionName),
    });
    return null;
  });
  return structure;
};

// Consumes form definition from service call, then transforms it into a page structure that can be rendered easily
const transformDefinition = (definition = []) => {
  // sort definition
  const sortedDefinition = getSortedDefinition(definition);

  // get (ordered) unique list of all sections
  const uniqueSections = getUniqueSections(sortedDefinition);

  // get (ordered) list of all items w/ groupName field
  const orderedGroups = sortedDefinition.filter(item => item.layoutGroupName);

  // get list of all unique group names
  const uniqueGroupNames = getUniqueGroupNames(orderedGroups);

  // build associative array of ordered groupName: [{item},...]
  const layoutGroupDict = buildGroupDict(uniqueGroupNames, orderedGroups);

  // derive children
  const children = deriveChildren(sortedDefinition, layoutGroupDict);

  // merges results into a final, renderable data structure
  const structure = createRenderStructure(uniqueSections, children);

  return structure;
};

// Action Creators & Thunks
const setValidationResult = validationResult => {
  const normalizedResult = transformResult(validationResult);
  return {
    type: SET_VALIDATION_RESULT,
    payload: normalizedResult,
  };
};

const setOpenHouseValidationResult = (uid, validationResult) => {
  const normalizedResult = transformResult(validationResult);
  return {
    type: SET_OPEN_HOUSE_VALIDATION_RESULT,
    payload: { [uid]: { ...normalizedResult } },
  };
};

const deleteOpenHouseValidationResult = uid => ({
  type: DELETE_OPEN_HOUSE_VALIDATION_RESULT,
  payload: uid,
});

// Dispatches room validation result to the reducer by UID
const setRoomValidationResult = (uid, validationResult) => {
  const normalizedResult = transformResult(validationResult);
  return {
    type: SET_ROOM_VALIDATION_RESULT,
    payload: { [uid]: { ...normalizedResult } },
  };
};

// Dispatches room UID to the reducer for deletion
const deleteRoomValidationResult = uid => ({
  type: DELETE_ROOM_VALIDATION_RESULT,
  payload: uid,
});

const setFormDataInitialized = () => ({
  type: SET_FORM_DATA_COMPLETE,
});

const setFormDataStatus = dataStatus => ({
  type: SET_FORM_DATA_STATUS,
  payload: dataStatus,
});

/*
  Loads form definition from api defined in apiService.js
  definitionType: Agent, Listing, Offices, etc
  operationType: Create, Edit, etc
  listingType: Optional parameter for when the listings form is being used - com, res, rnt, etc
*/
const loadFormDefinition = (operationType, definitionType, listingType, aclResourceID, aclResourceType, isCopyOperation = false) => async dispatch => {
  dispatch({ type: LOAD_FORM_DEFINITION, payload: { operationType, isCopyOperation } });

  try {
    let formType = definitionType;

    if (listingType) formType = listingType;

    let aclFieldPermissions = {};
    let aclPagePermissions = {};
    try {
      // Retrieve the ACL fields permissions for current resource.
      const aclCriteria = { action: operationType, formname: formType, uniqueId: aclResourceID ?? null };
      const aclDetails = await apiService.Acl.GetAclDetails(aclResourceType, aclCriteria);
      aclFieldPermissions = aclDetails.fieldPermissions;
      aclPagePermissions = aclDetails.pagePermissions;
    } catch (er) {
      console.error('Error: formGeneration getAclDetails', er);
    }

    const formDefinition = await apiService.Definitions.getFormDefinition(formType);
    formDefinition.Data = formDefinition.Data.map(field => {
      let formField = {};
      if (aclPagePermissions !== undefined && aclPagePermissions?.[field.PageName] === false) {
        formField = { ...field, IsVisible: false, IsDisabled: false };
      } else {
        let isDisabled = false;
        if (aclFieldPermissions?.[field.FieldName] !== undefined) {
          isDisabled = !aclFieldPermissions?.[field.FieldName];
        }
        formField = { ...field, IsVisible: true, IsDisabled: isDisabled };
      }
      return formField;
    });

    // get all the fields along with the properties we might need throughout the application
    const allFields = formDefinition.Data?.reduce((obj, item) => ({
      ...obj,
      [item.FieldName]: {
        DataType: item.datatype,
        InputType: item.inputType,
      },
    }), {});

    const defaultValues = formDefinition.Data?.filter(item => !!item.DefaultValue).reduce((obj, item) => {
      // Handle special case for date fields where the DefaultValue could be 'today'.
      // TODO: Think about allowing 'now', 'yesterday', 'tomorrow' or even things like 'today+x' or 'today-x' in future.
      let defaultValue = item.DefaultValue;
      if ((item.datatype === 'date' || item.datatype === 'datetime') && item.DefaultValue.toLowerCase() === 'today') {
        defaultValue = new Date().toLocaleDateString();
      }
      return ({
        ...obj,
        [item.FieldName]: defaultValue,
      });
    }, {});

    // transform form definition into data structure
    const pageStructure = transformDefinition(formDefinition.Data);

    dispatch({
      type: LOAD_FORM_DEFINITION_SUCCESS,
      payload: {
        formDefinition, allFields, defaultValues, listingType, pageStructure, operationType, definitionType,
      },
    });
  } catch (er) {
    console.error('Error: formGeneration loadFormDefinition', er);
    dispatch({ type: LOAD_FORM_DEFINITION_FAIL });
  }
};

const setComboSetValueDictionary = newEntry => ({
  type: SET_COMBO_DICTIONARY_ENTRY,
  payload: newEntry,
});

/*
  Starts dispatch to retrieve the data from the API response
  When there is a response, the data array is sent to payload for successful action
  If there is no response returned then a failed action with be dispatched
*/
const loadComboBoxOptions = (lookupTableNames, formType) => async dispatch => {
  dispatch({ type: LOAD_COMBO_BOX_OPTIONS });
  try {
    const comboBoxOptions = await apiService.Definitions.PostToLookupTable(lookupTableNames);
    // include everything that isn't governed by by propertyType
    const filteredOptions = [];
    comboBoxOptions.map(comboOption => { // single optionobject
      let addOption; // flag for adding to filter
      const filteredData = [];
      comboOption.data.map(dataPoint => { // this is single dataoption.
        if (dataPoint?.Parents) {
          dataPoint.Parents.map(dataParent => { // datapoint can have multiple parents.
            if (dataParent.ParentField === 'PropertyType') { // has listingParent //parameter 1
              if (dataParent.ParentCodes.includes(formType.toUpperCase())) { // force case parity.
                addOption = true;
                filteredData.push(dataPoint);
              }
            }
            return null;
          });
        }
        return null;
      });

      if (addOption) {
        const filterOption = comboOption;
        filterOption.data = filteredData;
        filteredOptions.push(filterOption);
      }
      return null;
    });

    filteredOptions.map(fOpt => {
      const found = comboBoxOptions.find(cbo => cbo.tableName === fOpt.tableName);
      found.data = fOpt.data;
      return null;
    });

    comboBoxOptions.map(opt => { // could not get ParentIsActive onto a datapoint any other way.
      opt.data.map(d => {
        // eslint-disable-next-line no-param-reassign
        d.ParentIsActive = true;
        return null;
      });
      return null;
    });

    dispatch({
      type: LOAD_COMBO_BOX_OPTIONS_SUCCESS,
      payload: { comboBoxOptions },
    });
  } catch (error) {
    console.error('Error: formGeneration loadComboBoxOptions', error);
    dispatch({ type: LOAD_COMBO_BOX_OPTIONS_FAIL });
  }
};

/* Dispatches city codes to lookup table to retrieve the city name from it
If a city name is found then the values are stored in redux
Otherwise an error is shown in console
cityNames is a dictionary that holds key: code, value: { code, description, active, sortOrder }
*/
const loadCityNames = lookupString => async dispatch => {
  dispatch({ type: LOAD_CITY_NAMES });
  try {
    const dict = {};
    const cityNames = await apiService.Definitions.PostToLookupTable(lookupString);
    cityNames.map(item => {
      (item.data).map(city => {
        dict[city.Code] = { ...city };
        return null;
      });
      return null;
    });
    dispatch({
      type: LOAD_CITY_NAMES_SUCCESS,
      payload: { cityNames: dict },
    });
  } catch (error) {
    console.error('Error: formGeneration loadCityNames', error);
    dispatch({ type: LOAD_CITY_NAMES_FAIL });
  }
};

const formSubmitted = () => ({ type: FORM_SUBMITTED });

export {
  deleteOpenHouseValidationResult,
  deleteRoomValidationResult,
  formSubmitted,
  loadCityNames,
  loadComboBoxOptions,
  loadFormDefinition,
  setComboSetValueDictionary,
  setFormDataInitialized,
  setFormDataStatus,
  setOpenHouseValidationResult,
  setRoomValidationResult,
  setValidationResult,
  transformDefinition,
  updateSectionAddClicks,
};
